module.exports = __webpack_public_path__ + "img/result-bg.3ab7546c.png";